import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { NpsFilterOption } from '@/Network/Types/Responses/NpsResponses'

export default class NpsConfigService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/config'
  }

  /**
   * Selects das telas de configuração do NPS (Associações / Avaliadores / Enquetes /
   * Avaliação). Usam rotas de grão NPS (`nps_settings_managing`) em vez das rotas admin de
   * outros domínios (schedules/healthUnits/companies `list-admin`), que exigiam papéis fora
   * do NPS e devolviam 403 para quem só tinha permissão de NPS. Lançam `ServiceError`
   * (padrão canônico de `error-handling.md`): "sem opções" e "falha ao carregar" precisam
   * ser distinguíveis no consumidor.
   */
  async listConfigHealthUnits(): Promise<NpsFilterOption[]> {
    try {
      const { data } = await request.get<NpsFilterOption[]>(
        `${this.getCompletePath()}/filters/health-units`
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as unidades.')
    }
  }

  async listConfigSchedules(): Promise<NpsFilterOption[]> {
    try {
      const { data } = await request.get<NpsFilterOption[]>(
        `${this.getCompletePath()}/filters/schedules`
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as escalas.')
    }
  }

  /**
   * web#2695 — o filtro de empresa distingue "sem empresas" de "falha ao carregar"
   * (ex.: 403 de permissão) para o consumidor exibir o estado certo: o service lança,
   * o componente exibe.
   */
  async listConfigCompanies(): Promise<NpsFilterOption[]> {
    try {
      const { data } = await request.get<NpsFilterOption[]>(
        `${this.getCompletePath()}/filters/companies`
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as empresas')
    }
  }
}
